import React, { Component } from 'react';
import Table from '../Table';
import { withStore } from '../store';
import { Link } from 'react-router-dom';


class MemberEvents extends Component {

    renderColumnName = (value, row, index, col) => {
                //to={'/event-attend/' + row.id}
        
        return (
            <li key={index} className={col.className ? "table-content " + col.className : "table-content"} style={{ "alignItems": "stretch" }}>
                <span style={{ 'backgroundColor': row['color'] }}></span>
                <Link 
                    to={{
                        pathname: '/event-assign/',
                        state: {
                            eventId: row.id,
                            userEventId: row.userEventId,
                            fromAdminPage: this.props.store.userInfo.authType == 'Admin'
                        }
                    }}>
                    <span className="display-flex flex-flow-column flex-nowrap justify-left">
                        <span style={{ "fontSize": "1.1em" }}>{value}</span>
                        <span className='chapter'>{row['chapter']}</span>
                    </span>
                </Link>
            </li>
        );
    }

    renderColumnDates(value, row, index, col) {
        const dateStyle = {
            fontWeight: 'bold'
        }

        var cellContent = value.map((date) => {
            return (
                <div>
                    <span style={dateStyle}>{date}</span>
                </div>
            )
        });

        return (
            <li key={index} className={col.className ? "table-content " + col.className : "table-content"} style={{ "alignItems": "stretch" }}>
                <span className="display-flex flex-flow-column flex-nowrap justify-left">
                    <span style={{ "fontSize": "1.1em" }}>{cellContent}</span>
                </span>
            </li>
        );
    }

    render() {
        const eventsList = this.props.events;
        const columns=[
            { title:"Title", accesor:"name", className:"borders-when-display-block", columnMinWidth:'max-content', render: this.renderColumnName},
            { title: "Dates", accesor: "dates", render: this.renderColumnDates}
        ];
        return (
            <div className='flex-nowrap flex-flow-column align-center mediaMin500-pl-pr-025 prpl-0 w-100'>
                {eventsList && eventsList.length > 0 &&
                    <Table columns={columns} data={eventsList} className={"break-at-500"} addHeadersForNarrowScreen={true}/>
                }
                {eventsList && eventsList.length === 0 &&
                    <p className="message-block mb-05 pr-1 pl-1">This user does not take part in any event.</p>
                }
            </div>
        );
    }
}

export default withStore(MemberEvents);


// WEBPACK FOOTER //
// ./src/components/member/MemberEvents.jsx